module.exports = __webpack_public_path__ + "static/img/6.fb55c54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zddcf/6.png
// module id = BEEO
// module chunks = 0